import RevolverModel from 'slotworks/integration/revolver/model/revolver-model';
import betModel from 'slotworks/model/bets/bet-model';
import BetModel from 'slotworks/model/bets/bet-model';
import GameState from 'slotworks/model/game-state';
import Gameplay from 'slotworks/model/gameplay/gameplay-model';
import FreespinRecord from 'slotworks/model/gameplay/records/freespin-record';
import Record from 'slotworks/model/gameplay/records/record';
import SpinRecord from 'slotworks/model/gameplay/records/spin-record';
import SlotDefinition from 'slotworks/model/slot-definition';
import { RecordBuilder } from 'slotworks/server/builders/record-builder';
import { OpenResponseSchema } from './open-response-schema';
import WildStickyRecorder from './wild-sticky-record';
import Components from 'slotworks/components/components';
import BonusBuyPrompt from 'components/bonus-buy/bonus-buy-prompt';
import doSettingsModel from 'model/do-settings-model';

class RecoveryBuilderBase implements RecordBuilder {
    public filter(data: any): boolean {
        let openResponse: OpenResponseSchema;

        if (data && data.data) {
            openResponse = data.data as OpenResponseSchema;
        }

        const isOpen = openResponse && openResponse.OPEN !== undefined;
        const isRecovery = isOpen && !GameState.getCurrentGame().getCurrentRecord();
        const isLateFreespins = isOpen && GameState.getCurrentGame().isRecovered && RevolverModel.isFreespin(openResponse.OPEN.game);

        return isRecovery || isLateFreespins;
    }

    public build(gameplay: Gameplay, data: any): Record[] {
        const openResponse: OpenResponseSchema = data.data as OpenResponseSchema;

        const isLateFreespins = GameState.getCurrentGame().isRecovered && RevolverModel.isFreespin(openResponse.OPEN.game);

        if (isLateFreespins) {
            const firstRecord = GameState.getCurrentGame().getFirstRecord();
            if (!(firstRecord instanceof FreespinRecord) && !firstRecord.beenPaid) {
                const preservedDummyWin = GameState.getCurrentGame().getFirstRecord().creditsWon;

                const dummySpinRecord = new FreespinRecord();
                GameState.getCurrentGame().records[0] = dummySpinRecord;
                this.populateDummyRecord(dummySpinRecord);
                dummySpinRecord.totalFreespins = openResponse.OPEN.state.total;
                dummySpinRecord.remainingFreespins = openResponse.OPEN.state.remain;
                const recoveredFSWin = parseFloat(openResponse.OPEN.state.total_win_cash as any);
                dummySpinRecord.creditsWon = recoveredFSWin + preservedDummyWin;

                GameState.getCurrentGame().totalCreditsWon += parseFloat(recoveredFSWin as any);
            }

            return [];
        }

        if (openResponse.USER) {
            gameplay.balance = openResponse.USER.balance;
        }

        RevolverModel.game = openResponse.OPEN.game;
        RevolverModel.bet = JSON.stringify(openResponse.OPEN.bet_state);

        const recoveryRecords: Record[] = [];

        if (openResponse.OPEN.game.indexOf('BASE') === -1 || openResponse.OPEN.persisted_progress) {
            gameplay.isRecovered = true;

            const isFreeSpin = RevolverModel.isFreespin(openResponse.OPEN.game);
            const dummySpinRecord = isFreeSpin ? new FreespinRecord() : new SpinRecord();
            this.populateDummyRecord(dummySpinRecord);

            recoveryRecords.push(dummySpinRecord);

            if(openResponse.OPEN.game.indexOf('BASE') === -1) {
                const betState = openResponse.OPEN.bet_state;
                const coinLevel = SlotDefinition.coinSizes[betState.coin_level - 1];
                BetModel.setDefaults(SlotDefinition.stakes[betState.bet_level - 1], betState.lines || betModel.getSelectedLines(), coinLevel);
                Components.paytable.refreshBetOptions();
                Components.header.refreshOptions();

                if((openResponse.OPEN.state as any).buyoutGame == true) {
                    gameplay.isBuyout = true;
                    const bet = betModel.getTotalBet();
                    if(isFreeSpin) {
                        gameplay.totalBet = bet * BonusBuyPrompt.MULTIPLIER_OS;
                    } else {
                        gameplay.totalBet = bet * BonusBuyPrompt.MULTIPLIER_M3;
                        doSettingsModel.isCurrentBonusBuyOut = true;
                        doSettingsModel.totalBetOnBuyoutBonus = bet;
                    }
                }
            }

            this.recoverBonuses(gameplay, data, openResponse, dummySpinRecord, recoveryRecords);
        }

        return recoveryRecords;
    }

    protected recoverBonuses(gameplay: Gameplay, data: any, openResponse: OpenResponseSchema, dummySpinRecord: SpinRecord, recoveryRecords: Record[]) {
        if (openResponse.OPEN.state.total_bonus_games_win_amount) {
            gameplay.recoveredFreeSpinTotalWin += parseFloat(openResponse.OPEN.state.total_bonus_games_win_amount as any);
        }

        if (RevolverModel.isFreespin(openResponse.OPEN.game)) {
            const freespinRecord = dummySpinRecord as FreespinRecord;
            freespinRecord.freespinsTriggered = true;
            freespinRecord.beenPaid = true;

            freespinRecord.totalFreespins = openResponse.OPEN.state.total;
            freespinRecord.remainingFreespins = openResponse.OPEN.state.remain;
            freespinRecord.isFreespinsComplete = openResponse.OPEN.state.is_complete;
            freespinRecord.gameName = openResponse.OPEN.state.game;

            gameplay.recoveredTotalFreespins = openResponse.OPEN.state.total;

            const wildStickyRecord = new WildStickyRecorder();
            wildStickyRecord.gameName = openResponse.OPEN.game;
            wildStickyRecord.stickedWildsList = openResponse.OPEN.state.stickedWildsList;
            wildStickyRecord.persistedProgress = openResponse.OPEN.persisted_progress;
            freespinRecord.results.push(wildStickyRecord);

            if (openResponse.OPEN.state.total_win_cash && gameplay.recoveredFreeSpinTotalWin === 0) {
                gameplay.recoveredFreeSpinTotalWin = parseFloat(openResponse.OPEN.state.total_win_cash as any);
            }
        }

        gameplay.totalCreditsWon += parseFloat(gameplay.recoveredFreeSpinTotalWin as any);
    }

    private populateDummyRecord(record: SpinRecord) {
        record.creditsWon = 0;
        record.reelset = [];
        record.grid = [];
        record.stops = [];
        record.results = [];
        record.freespinsWon = 0;
    }
}

export default RecoveryBuilderBase;



// WEBPACK FOOTER //
// ./src/integration/recovery-builder-base.ts